import React, {useState, useCallback, useRef} from "react";
import './buildings.scss'
import {getPropsFromState} from "../../../redux/mapStateToProps";
import {AddSubscribers} from "../../../redux/actions";
import {connect} from "react-redux";
import {AboutArrIcon, BuildBuyIcon, BuildIcon, BuildReservedIcon} from "../../../assets/images";
import MouseTracker from "../../../components/MouseTracker";
import {BUILDINGS_BADGE_TYPES} from "../../../constants/constants";
import {Link} from "react-router-dom";
import {getUrlWithLocal} from "../../../utils/getUrlWithLocal";
import {Swiper, SwiperSlide} from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import {Navigation, Pagination,Autoplay} from 'swiper/modules';
import {generateFileMediaUrl} from "../../../utils/generateMediaUrl";


function Buildings(props) {
    const {badges,areas,areaData,staticTexts} = props;
    const [isBuildingVisible, setBuildingVisible] = useState(false)
    const [activeIndex,setActiveIndex] = useState(false);
    const [buildType, setBuildType] = useState({
        color:'',
        title:''
    });
    const sliderRef = useRef(null);
    if (badges?.length > 0) {
        badges[0].icon = <BuildBuyIcon />;
        badges[1].icon = <BuildReservedIcon />;
        badges[2].icon = <BuildIcon />;
    }

    function onMouseEnter(color,title) {
        setBuildType({
            color:color,
            title:title
        });
        setBuildingVisible(true);
    }

    function onMouseLeave() {
        setBuildType({
            color:'',
            title:''
        });
        setBuildingVisible(false)
    }

    const handlePrev = useCallback(() => {
        if (!sliderRef.current) return;
        //@ts-expect-error
        sliderRef.current?.swiper?.slidePrev();
    }, []);

    const handleNext = useCallback(() => {
        if (!sliderRef.current) return;
        //@ts-expect-error
        sliderRef.current?.swiper?.slideNext();
    }, []);

    return <div className="buildings_wrapper">
        <div className={'top_block'}>
            <div className={'title_block'}>
                {staticTexts?.homepage_building_title || 'Выбирайте ваш дом с вашим числом'}
            </div>
            <div className={'description_block'}>
                {staticTexts?.homepage_building_subtitle}
                <span>{staticTexts?.homepage_building_subtitle2}</span>
            </div>
        </div>
        <div className={'bottom_block'}>
            {
                areas?.list?.map((item, index) => {
                    const badge = badges?.find(badge => badge.id === item?.badge.id);
                    return (
                        <Link to={getUrlWithLocal(`/place/${item?.id}`)} className={`build_item`} key={index}
                             onMouseEnter={() => onMouseEnter(badge?.color,badge?.title)} onMouseLeave={onMouseLeave}>
                            <div className={`icons_block 
                            ${item?.badge.id === BUILDINGS_BADGE_TYPES.sold ? 'sold' : ''} 
                            ${item?.badge.id === BUILDINGS_BADGE_TYPES.booked ? 'booked' : ''}`}>
                               {badge?.icon}
                                <span className={'build_number'}>{item?.areaNumber}</span>
                            </div>
                            <span className={'build_bord'} />
                            <MouseTracker visible={isBuildingVisible}
                                          offsetX={15}
                                          offsetY={10}>
                                <div className={'type_block'} style={{backgroundColor:buildType?.color}}>
                                    {buildType?.title}
                                </div>
                            </MouseTracker>
                        </Link>
                    );
                })
            }
        </div>
        <div className={'bottom_block_mobile'}>
            <button onClick={handlePrev} className={'prev_btn'}>
                {'<'}
            </button>
            <Swiper
                effect={'flip'}
                spaceBetween={'16'}
                watchSlidesProgress={true}
                slidesPerView={4}
                pagination={false}
                modules={[Autoplay,Navigation, Pagination]}
                ref={sliderRef}
                navigation={false}
                loop={true}
                allowTouchMove={true}
                autoplay={{
                    delay: 2000,
                    disableOnInteraction: false,
                }}
                onRealIndexChange={(swiper) => {
                    setActiveIndex(swiper.realIndex)
                }}
                breakpoints={{
                    400: {
                        slidesPerView: 5,
                    },
                    600: {
                        slidesPerView: 5,
                    },
                    800: {
                        slidesPerView: 5,
                    },
                    1300: {
                        slidesPerView: 5,
                    },
                    1600: {
                        slidesPerView: 5,
                    },
                }}
            >

                {
                    areas?.list?.map((item, index) => {
                        const badge = badges?.find(badge => badge.id === item?.badge.id);
                        return (
                            <SwiperSlide key={index}>
                                <Link to={getUrlWithLocal(`/place/${item?.id}`)} className={`build_item`} key={index}
                                      onMouseEnter={() => onMouseEnter(badge?.color,badge?.title)} onMouseLeave={onMouseLeave}>
                                    <div className={`icons_block ${item?.badge.id === BUILDINGS_BADGE_TYPES.sold ? 'sold' : ''}  ${item?.badge.id === BUILDINGS_BADGE_TYPES.booked ? 'booked' : ''}`}>
                                        {badge?.icon}
                                        <span className={'build_number'}>{item?.areaNumber}</span>
                                    </div>
                                    <span className={'build_bord'} />
                                    <MouseTracker visible={isBuildingVisible}
                                                  offsetX={15}
                                                  offsetY={10}>
                                        <div className={'type_block'} style={{backgroundColor:buildType?.color}}>
                                            {buildType?.title}
                                        </div>
                                    </MouseTracker>
                                </Link>
                            </SwiperSlide>
                        );

                    })
                }
            </Swiper>
            <button onClick={handleNext} className={'next_btn'}>
                >
            </button>
        </div>
    </div>
}
const mapStateToProps = (state) => getPropsFromState(state, [
    'staticTexts',
    'requestLoading',
    'badges',
    'areas',
    'areaData',
]);

const mapDispatchToProps = {
    AddSubscribers
};

export default connect(mapStateToProps, mapDispatchToProps)(Buildings);